export function stringToRegex(str) {
    if (str === undefined || str === null) {
        return str;
    }

    const match = str.match(/^\/(.*)\/(.*)$/);

    if (match) {
        return new RegExp(match[1], match[2]);
    }

    return new RegExp(str);
}

export function hasWhiteSpace(str) {
    if (str === undefined || str === null) {
        return str;
    }
    return !new RegExp(/^\S*$/).test(str);
}
